import { render } from "./Tabs.vue?vue&type=template&id=f2023352&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=f2023352&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2023352"],['__file',"src/ui-components/Tabs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f2023352"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f2023352', __exports__)) {
    api.reload('f2023352', __exports__)
  }
  
  module.hot.accept("./Tabs.vue?vue&type=template&id=f2023352&scoped=true", () => {
    api.rerender('f2023352', render)
  })

}


export default __exports__